import { PropsWithChildren } from "react";
import { FormattedMessage } from "react-intl";
import { PropsWithClassName } from "../../../models/props-with-class-name";
import { Button } from "@shltelemedicine/shl-ui-lib";
import closeIcon from "../../../assets/shared/close.svg";

type CancelButtonProps = {
  disabled?: boolean;
  onClick?: () => void;
};

const CancelButton = ({
  disabled,
  onClick,
  className,
  children,
}: PropsWithChildren<PropsWithClassName<CancelButtonProps>>) => {
  return (
    <Button
      className={`${className} capitalized `}
      bgColor="transparent linear-gradient(180deg, #717689 0%, #393B45 100%) 0% 0% no-repeat padding-box"
      onClick={onClick}
      icon={{ src: closeIcon, width: 18, height: 18 }}
      disabled={disabled}
    >
      {children ? (
        children
      ) : (
        <FormattedMessage id="GLOBAL.CANCEL" defaultMessage="Cancel" />
      )}
    </Button>
  );
};

export default CancelButton;
